module.exports = __webpack_public_path__ + "img/nsi_logo.17a94efa.png";